
import { readOnly, useReadOnly } from '../common/DataView';
import { useStatefulApiEditable } from '../common/Editable';
import { useApiFilteredList } from '../common/FilteredPaginatedList';
import { ListProps, SectionListLayout, useListWithEditable, useStatefulList } from '../common/List';
import { useStatefulToggleable } from "../common/Toggleable";
import { PlatformDomainCard } from './PlatformDomainCard';
import { PlatformDomainEditable } from './PlatformDomainEditable';
import { PlatformDomainCrudService } from '../../apis/mgmt/PlatformDomainCrudService';
import { findPlatformDomainByDomain, PlatformDomain } from '../../apis/mgmt/api';
import { Modal } from '../common/Modal';

export const usePlatformDomainListByDomain = function (props: {
    domainId: string | undefined,
}) {
    return useApiFilteredList<string,PlatformDomain>({
        filterProps: useReadOnly(props.domainId),
        listProps: useStatefulList<PlatformDomain>(),
        apiQueryFunc: (domainId) => findPlatformDomainByDomain(domainId, {size:1000}).then((response) => {
            return Promise.resolve({ data: response.data?.content || [] });
        }),
    });
};

export function PlatformDomainSectionList(props: {
    listProps: ListProps<PlatformDomain>,
    defaultAddItemData?: PlatformDomain,
    title?: string,
}) {

    const platformdomainToggle = useStatefulToggleable(false);
    const { listProps, editableProps: platformdomainEditableProps } = useListWithEditable<PlatformDomain>({
        listProps: props.listProps,
        editableProps: useStatefulApiEditable(PlatformDomainCrudService, undefined, undefined, platformdomainToggle),
        toggle: platformdomainToggle,
        defaultAddItemData: props.defaultAddItemData,
    });

    const { onAddItem, onEditItem } = listProps;
    const data = listProps.data;

    return (
        <>
            <SectionListLayout
                title={props.title || 'PlatformDomains'}
                onCreateClick={onAddItem}
                addButtonState={
                    props.defaultAddItemData?.domain?.id? 'visible' : 'disabled'
                } 
            >
                {data && data.map((itemData: PlatformDomain) => (
                    <PlatformDomainCard
                        key={itemData.id}
                        data={itemData} {...readOnly}
                        onClick={onEditItem}
                    />
                ))}
            </SectionListLayout>
            <Modal mode="FullPage" 
                title={platformdomainEditableProps.data?.id? "Editando tarea" : "Nueva tarea"}
                toggle={platformdomainToggle} onCancel={platformdomainEditableProps.cancel}
            >
                <PlatformDomainEditable {...platformdomainEditableProps} />
            </Modal>
        </>
    );

}